import * as types from '../actionTypes/MyListActionTypes';

const initialValue = {
    isLoading: false,
    myList: {},
    myListError: {},
};

export default function MyListNameReducer(state = initialValue, action = {}) {
    switch (action.type) {
        case types.ADD_MY_LIST_NAME: {
            const { myListName } = action.payload;
            const isLoading = false;
            return {
                ...state,
                isLoading,
                myListName,
            };
        }
        case types.REMOVE_MY_LIST_NAME: {
            const myListName = '';
            const isLoading = false;
            return {
                ...state,
                isLoading,
                myListName,
            };
        }
        case types.CREATE_MY_LIST: {
            const isLoading = true;
            return {
                ...state,
                isLoading,
                myListName: '',
                myList: {},
                myListError: {},
            };
        }
        case types.CREATE_MY_LIST_REQ_COMPLETED: {
            const isLoading = false;
            return {
                ...state,
                isLoading,
                myListName: '',
            };
        }
        case types.CREATE_MY_LIST_SUCCESS: {
            const myList = action.payload;
            return {
                ...state,
                myList,
                myListError: {},
                myListName: '',
                isLoading: false,
            };
        }
        case types.CREATE_MY_LIST_FAILURE: {
            const myListError = action.payload;
            return {
                ...state,
                myListError,
                myList: {},
                isLoading: false,
            };
        }

        default:
            return state;
    }
}
